import { QrScanPage } from "../../containers/QrScanner/QrScanPage";

function QrScannerPage() {
  return <QrScanPage />;
}

export { QrScannerPage };
